(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/configs/assets/javascripts/overrides/sport/basketball.js') >= 0) return;  svs.modules.push('/components/sportinfo/configs/assets/javascripts/overrides/sport/basketball.js');
"use strict";


const newEnetpulseWidgets = svs.core.detect.feature('ft-enetpulse-new');
const _svs$components$sport = svs.components.sportinfo.common.constants,
  SportinfoPathNames = _svs$components$sport.SportinfoPathNames,
  SvsViewType = _svs$components$sport.SvsViewType;
const commonConfig = svs.components.sportinfo.configs.sportConfigs.commonConfig;
const ContentProvider = svs.components.sportinfo.common.constants.ContentProvider;
const ConfigBuilder = svs.components.sportinfo.configBuilder.ConfigBuilder;
const _ConfigBuilder$addTab = new ConfigBuilder().addTab(SportinfoPathNames.MatchInfo, tab => {
    tab.setAll([{
      type: SvsViewType.MatchInfo,
      provider: ContentProvider.Svs
    }]);
  }).addTab(SportinfoPathNames.News, tab => {
    tab.setAll([{
      type: SvsViewType.News,
      provider: ContentProvider.Svs
    }]);
  }).build(),
  enetpulseMenuItems = _ConfigBuilder$addTab.menuItems,
  enetpulseContent = _ConfigBuilder$addTab.content;
setGlobal('svs.components.sportinfo.configs.sportConfigs.sportTypeOverrides', {
  basketballConfig: newEnetpulseWidgets ? {
    menuItems: enetpulseMenuItems,
    content: enetpulseContent,
    config: 'basketball' 
  } : commonConfig
});

 })(window);